// src/analytics.js
import ReactGA from "react-ga4";

const META_PIXEL_ID = "981056864503971";
const isBrowser = typeof window !== "undefined";

// No-op kept for backward-compat call sites; react-ga4 is initialised in index.js
export function initAnalytics() {}

// Log custom events safely via react-ga4
export function gaEvent(eventName, params = {}) {
  try {
    ReactGA.event(eventName, { ...params, timestamp: Date.now() });
  } catch (error) {
    console.warn("GA log failed:", error);
  }
}

export function initMetaPixel() {
  if (!isBrowser || window.fbq) {
    return;
  }

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", META_PIXEL_ID);
}

export function trackMetaPageView() {
  if (!isBrowser || typeof window.fbq !== "function") {
    return;
  }

  window.fbq("track", "PageView");
}

export { META_PIXEL_ID };
